<template>
    <div class="flowNodeDialog">
        <div v-if="dialogType==1">
            <el-dialog title="通用审批流配置" :visible.sync="dialogVis" @close="beforeCloseHandle">
                <el-form :model="form" :rules="formRules" ref="formRef">
                    <el-form-item label="通用审批等级：" prop="handleLevel" :label-width="formLabelWidth">
                        <el-input-number
                            v-model="form.handleLevel"
                            controls-position="right"
                            @change="levelHandleChange"
                            :min="1"
                            :max="heighestLevel"
                        ></el-input-number>
                    </el-form-item>
                    <el-form-item
                        v-for="(element,index) in form.levleList"
                        :key="index"
                        :label="'通用'+(element.handleLevel)+'级审批角色：'"
                        :prop="`levleList.${index}.handle.name`"
                        :label-width="formLabelWidth"
                        :rules="formRules.handleRole"
                    >
                        <el-select v-model="element.handle" value-key="id">
                            <el-option
                                v-for="(item) in selectOptions"
                                :key="item.id"
                                :label="item.name"
                                :value="item"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancelHandle">取 消</el-button>
                    <el-button type="primary" @click="sureHandle">确 定</el-button>
                </div>
            </el-dialog>
        </div>
        <div v-if="dialogType==2">
            <el-dialog
                title="个性化审批流配置"
                :visible.sync="dialogVis"
                @close="beforeCloseHandle"
                width="80%"
            >
                <el-table
                    ref="tableRef"
                    :data="tableDataList"
                    border
                    :highlight-current-row="true"
                    :header-row-style="{ background:'#E3ECFB'}"
                >
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column property="date" label="所属单位/科室" width="400">
                        <template slot-scope="scope">
                            <!-- <select-depart-tree
                                :selectDisabled="selectDisabled"
                                :ref="'selectDepartTreeRef'+scope.$index"
                                :modelValue.sync="supervisionIds"
                                :isMultiple="true"
                                @handleDeptType="(val)=>changeDept(val,'5',scope)"
                            ></select-depart-tree> -->
                            <el-select v-model="scope.row.tradeIdList" value-key="value" style="width:100%;" multiple :disabled="selectDisabled">
                                <el-option v-for="(item,index) in transactionCenterList" :key="index" :label="item.orgName" :value="item.id"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column property="handleLevel" label="审批等级" width="160">
                        <template slot-scope="scope">
                            <el-input-number
                                :disabled="selectDisabled"
                                v-model="scope.row.handleLevel"
                                controls-position="right"
                                @change="(currentValue, oldValue)=>tableLevelHandleChange(currentValue, oldValue,scope)"
                                :min="0"
                                :max="heighestLevel"
                                size="small"
                            ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column property="address" label="扩展审批流" >
                        <template slot-scope="scope">
                            <el-form :model="tableForm" :rules="tableFormRules" ref="tableFormRef" :class="scope.row.handleLevel==0?'grayBg':''">
                                <el-form-item
                                    v-for="(element,index) in scope.row.rules"
                                    :key="index"
                                    :label="(element.handleLevel)+'级审批角色：'"
                                    :label-width="formLabelWidth"
                                >
                                    <!--  
                                     :prop="`rules.${index}.id`"
                                    :rules="tableFormRules.handleRole"
                                    -->
                                    <el-select
                                        :disabled="selectDisabled"
                                        v-model="element.handle"
                                        value-key="id"
                                        @change="(val)=>tableHandleChange(val,scope,element.handleLevel)"
                                    >
                                        <el-option
                                            v-for="(item) in selectOptions"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100" align="center">
                        <template slot-scope="scope">
                            <el-button
                                size="mini"
                                type="text"
                                @click="handleDelete( scope.$index)"
                                :disabled="selectDisabled"
                            >
                                <i class="el-icon-delete" style="font-size:20px;"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="addRows">
                    <el-button
                        class="el-icon-plus"
                        type="text"
                        @click="addRowsHandle"
                        :disabled="selectDisabled"
                    >添加一行</el-button>
                </div>
                <div class="tipText">
                    <div>备注：某单位/科室不需要审批时 ，审批级别选择“0级”；</div>
                    <div class="warp">需要比通用‘更多/更少’的审批级别时，直接填写审批级别数。</div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancelHandle">{{selectDisabled?'返回':'取消'}} </el-button>
                    <el-button type="primary" @click="changeHandle" v-if="selectDisabled">修改</el-button>
                    <el-button type="primary" @click="tableSaveHandle" v-if="!selectDisabled">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import selectDepartTree from "./selectDepartTree";
import {
    apiPostSaveList,
    apiGetHandleRules,
    apiSaveCustomizationLists,
    apiGetCustomizationList,
    apiGetHandleLevel
} from "@/server/configPage.js";
export default {
    props: {
        dialogFormVisible: {
            type: Boolean,
            default: false
        },
        dialogType: {
            type: Number,
            default: 1 //1表示 通用审批流 2 表示个性化审批流
        },
        selectOptions: {
            type: [],
            default: () => []
        },
        flowId: {
            type: String,
            default: ""
        }
    },
    components: { selectDepartTree },
    data() {
        return {
            dialogVis:false,
            form: {
                handleLevel: 1,
                levleList: [
                    {
                        type: 0,
                        handleLevel: 1,
                        handleRole: "",
                        rulesCode: "DEFAULT",
                        handleRoleName: "",
                        handle: {}, // 暂存选中的option
                        flowId: this.flowIdCopy
                    }
                ]
            },
            tableForm: {
                handleLevel: 0,
                levleList: []
            },
            tableFormRules: {
                handleRole: [
                    {
                        required: true,
                        message: "请选择审批角色",
                        trigger: "change"
                    }
                ]
            },
            formLabelWidth: "160px",
            formRules: {
                level: [
                    {
                        required: true,
                        message: "请输入通用审批等级",
                        trigger: "blur"
                    }
                ],
                handleRole: [
                    {
                        required: true,
                        message: "请选择审批角色",
                        trigger: "change"
                    }
                ]
            },
            tableDataList: [],
            supervisionIds: [],
            selectDisabled: true,
            flowIdCopy: "",
            heighestLevel:null,
            transactionCenterList: [],
        };
    },
    watch: {
        flowId: {
            immediate: true,
            handler(val) {
                this.flowIdCopy = val;
                if(this.flowIdCopy){
                    this.getCustomList(1)
                    this.getProcessFlow(0)
                }
            }
        },
        dialogFormVisible:{
            immediate: true,
            handler(val) {
                this.dialogVis = val;
            }
        }
    },
    mounted(){
        this.$http.post('/suite/loadTrades').then(res => {
                this.transactionCenterList = res.data || []
            })
        this.getConfigLevel()
    },
    methods: {
        getConfigLevel(){
            apiGetHandleLevel().then((res)=>{
              if(res.data.code==1){
                this.heighestLevel=res.data.data*1
              }else{
                this.$message.error(res.data.msg)
              }
            })
        },
        setSelectReview(item,index){
            this.$nextTick(() => {
                if( this.$refs['selectDepartTreeRef'+index]){
                    this.$refs['selectDepartTreeRef'+index].reViewTreeOption(
                    "code",
                    item.supervisionIds
                    );
                }
            });
        },
        getProcessFlow(type) {
            let params = {
                flowId: this.flowIdCopy,
                type: type
            };
            apiGetHandleRules({
                page: 1,
                rows: 5,
                filter: params
            }).then(res => {
                if (res.data && res.data.rows) {
                    let dataInfo = res.data.rows;
                    // 从小到大排序
                    dataInfo.sort((a, b) => {
                        return a.handleLevel - b.handleLevel;
                    });
                    // handle 显示使用
                    dataInfo.forEach(item => {
                        item.handle = {
                            id: item.handleRole,
                            name: item.handleRoleName
                        };
                    });
                    this.form.levleList = dataInfo;
                    this.form.handleLevel = res.data.total;
                    // 通用配置为空的情况 默认给一个空的
                    if(this.form.levleList.length==0){
                        this.form.levleList= [
                            {
                                type: 0,
                                handleLevel: 1,
                                handleRole: "",
                                rulesCode: "DEFAULT",
                                handleRoleName: "",
                                handle: {}, // 暂存选中的option
                                flowId: this.flowIdCopy
                            }
                          ]
                          this.form.handleLevel=1
                    }
                    this.$emit("update:commonBadge", this.form.handleLevel);
                }
            });
        },
        getCustomList(type) {
            let params = {
                flowId: this.flowIdCopy,
                type: type
            };
            apiGetCustomizationList(params).then(res => {
                if (res.data.code == 1) {
                    let dataInfo = res.data.data;

                    dataInfo.forEach(item => {
                        item.supervisionIds=[]
                        // item.handleLevel = item.rules.length;
                        item.deptMap.forEach(el => {
                            // 这里后续需要换成el.key 值  涉及到封装树形下拉的回显
                            item.supervisionIds.push(el.value);
                        });
                        // lever等级为0 则为假数据
                        if( item.rules&&item.rules.length==1&&item.rules[0].handleLevel==0){
                             item.rules=[]
                        }else{
                                // 从小到大排序
                            item.rules.sort((a, b) => {
                                return a.handleLevel - b.handleLevel;
                            });
                            item.rules.forEach(el => {
                                el.handle = {
                                    id: el.handleRole,
                                    name: el.handleRoleName
                                };
                            });
                        }
                       
                    });
                    this.tableDataList = dataInfo;
                    this.$emit("update:specialBadge",  this.tableDataList.length);
                    this.$emit("update:dataList",  this.tableDataList);
                }
            });
        },
        levelHandleChange(currentValue, oldValue) {
            let flag = currentValue - oldValue;
            if (flag > 0) {
                for(let i=0;i<flag;i++){
                    this.form.levleList.push({
                    type: 0,
                    handleLevel: oldValue+1+i,
                    handleRole: "",
                    handleRoleName: "",
                    rulesCode: "DEFAULT",
                    handle: {},
                    flowId: this.flowIdCopy
                   });
                }
               
            } else {
                // 此时flag 为负数
                for(let i=0;i<-flag;i++){
                     // 删除最后一项
                     this.form.levleList.pop();
                }
              
            }
        },
        sureHandle() {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.dealWithData(this.form.levleList);
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        tableSaveHandle() {
            let flag = true;
            if(this.tableDataList.length==0){
                this.tableDataList[0]={}
                this.tableDataList[0].handleLevel=0
                this.tableDataList[0].flowId=this.flowIdCopy
                this.tableDataList[0].deptMap=[{key:'',value:''}]
                this.tableDataList[0].rules=null
            }else{
                this.tableDataList.forEach(item => {
                item.deptMap = undefined;
                if(item.handleLevel==0){
                    item.rules=[{
                    type: 1,
                    handleLevel: 0,
                    handleRole: "",
                    handleRoleName: "",
                    rulesCode: '',
                    handle: {},
                    flowId: this.flowIdCopy
                    }]
                }else{
                    item.rules.forEach(el => {
                    if (!el.handleRole) {
                        flag = false;
                    }
                });
                }
            });
            }
            

            if (flag) {
                this.dealWithData2(this.tableDataList);
            } else {
                this.$message.error("角色不能为空");
            }
            // 个性化配置保存
            // this.$refs.tableFormRef.validate(valid => {
            //     if (valid) {

            //     } else {
            //         console.log("error submit!!");
            //         return false;
            //     }
            // });
        },
        dealWithData2(list) {
            console.log(list, 111000);
            // 个性化 自定义配置
            apiSaveCustomizationLists(list).then(res => {
                if (res.data.code == 1) {
                    this.$message.success(res.data.msg);
                    this.$emit("update:dialogFormVisible", false);
                    this.getCustomList(1)
                }else{
                    this.$message.error(res.data.msg);
                }
            });
        },
        dealWithData(list) {
            list.forEach(item => {
                item.flowId = this.flowIdCopy;
                item.handleRole = item.handle.id;
                item.handleRoleName = item.handle.name;
                delete item.handle;
            });
            this.saveFunc(list);
        },
        saveFunc(dataList) {
            //type类型0默认 1自定义
            if (dataList && dataList[0].type == 0) {
                apiPostSaveList(dataList).then(res => {
                    if (res.data.code == 1) {
                        this.$message.success(res.data.msg);
                        this.$emit("update:commonBadge", this.form.handleLevel);
                        this.$emit("update:dialogFormVisible", false);
                        this.getProcessFlow(0)
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            }
        },
        cancelHandle() {
            this.$emit("update:dialogFormVisible", false);
        },
        handleDelete(index) {
            this.tableDataList.splice(index, 1);
        },
        changeHandle() {
            this.selectDisabled = false;
        },
        changeDept(val, flag, scope) {
            let rowsInfo = scope.row;
            this.supervisionIds = [];
            this.tableDataList[scope.$index].deptMap = [];
            // let codeStr = [];
            // let idStr = [];
            if (flag == "5") {
                val.forEach(item => {
                    if (item.type !== "region" && !item.children) {
                        this.supervisionIds.push({
                            rulesCode: item.code,
                            rulesId: item.id
                        });
                        // codeStr.push(item.code);
                        // idStr.push(item.id);
                        this.tableDataList[scope.$index].deptMap.push({
                            key: item.id,
                            value: item.code
                        });
                    }
                });
            }
            // 设置表格 部门信息
            // this.tableDataList[scope.$index].deptMap = {
            //     rulesCode: codeStr.join(","),
            //     rulesId: idStr.join(",")
            // };
        },
        tableHandleChange(val, scope, level) {
            // this.tableDataList[scope.$index].handleLevel=this.tableForm.handleLevel
            // 设置表格角色信息
            // this.tableDataList[scope.$index].rules[level - 1] = {
            //     type: 1,
            //     handleLevel: level,
            //     handleRole: val.id,
            //     handleRoleName: val.name,
            //     rulesCode: "DEFAULT",
            //     flowId: this.flowIdCopy,
            //     handle: { id: val.id, name: val.name }
            // };
            this.$nextTick(() => {
                this.$set(this.tableDataList[scope.$index].rules, level - 1, {
                    type: 1,
                    handleLevel: level,
                    handleRole: val.id,
                    handleRoleName: val.name,
                    rulesCode: "DEFAULT",
                    flowId: this.flowIdCopy,
                    handle: { id: val.id, name: val.name }
                });
                this.$forceUpdate();
            });
        },
        tableLevelHandleChange(currentValue, oldValue, scope) {
            let flag = currentValue - oldValue;
            if (flag > 0) {
                for(let j=0;j<flag;j++){
                    this.tableDataList[scope.$index].rules.push({
                    type: 1,
                    handleLevel: oldValue+1+j,
                    handleRole: "",
                    handleRoleName: "",
                    rulesCode: "DEFAULT",
                    handle: {},
                    flowId: this.flowIdCopy
                });
                }
               
            } else {
                for(let j=0;j<-flag;j++){
                    // 删除最后一项
                    this.tableDataList[scope.$index].rules.pop();
                }
             
            }
        },
        addRowsHandle() {
            this.tableDataList.push({
                flowId: this.flowIdCopy,
                deptMap: [], // 部门code id
                handleLevel: 0,
                rules: [],
                type: 1
            });
        },

        beforeCloseHandle() {
            this.$emit("update:dialogFormVisible", false);
        }
    }
};
</script>
<style lang="less">
.flowNodeDialog {
/**
改变边框颜色
 */
 .el-table--border, .el-table--group {
    border: 1px solid #8A8A8A!important;
}
/**
改变表格内竖线颜色
 */
.el-table--border  td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 1px solid #8A8A8A!important;
}
/**
改变表格内行线颜色
 */
.el-table  td, .el-table th.is-leaf  {
    border-bottom: 1px solid #8A8A8A!important;
}
 
.el-table thead tr th{
    border-color: #8A8A8A;
    background-color: #EFF3F6 ;
}
}
</style>

<style lang="less" scoped>
.flowNodeDialog {
    .grayBg{
   background-color:  rgb(242,242,242);
}
    .addRows {
        width: 100%;
        height: 40px;
        line-height: 40px;
        color: #1890ff;
        text-align: center;
        border-left: 1px solid #1890ff;
        border-right: 1px solid #1890ff;
        border-bottom: 1px solid #1890ff;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        cursor: pointer;
    }
    .tipText {
        margin-top: 20px;
        color: red;
        
        .warp {
            text-indent: 3em;
        }
    }
}
</style>